<template>
  <div id="homePage">
    <div class="Grid6DF38708" :style="backImg">
      <div class="returnBtn">
        <md-icon name="arrow-left" size="lg"  @click="goBack" />
      </div>
<!--      <p class="myPosition" @click="toMyPosition">-->
<!--        {{$t('label.label41')}}-->
<!--      </p>-->
      <div class="GridA80946D5">
        <span :text="'文本内容'" class="text5631D312">{{$t('label.label0')}}</span>
<!--        <span :text="'文本内容'" class="text5631D313">{{$t('label.label1')}}</span>-->
      </div>
      <div class="newPlans">
<!--        <div class="newPlan" :style="backImg1" @click="toPage('planForChange')">-->
<!--          <span>-->
<!--            {{$t('label.label5')}}-->
<!--          </span>-->
<!--        </div>-->
        <img class="newPlan" :src="backImg1"/>
<!--        <div class="newPlan" :style="backImg3" @click="toPage('planForBirth')">-->
<!--          <span>-->
<!--            {{$t('label.label7')}}-->
<!--          </span>-->
<!--        </div>-->
<!--        <div class="newPlan" :style="backImg4" @click="toPage('planForPerMonth')">-->
<!--          <span>-->
<!--            {{$t('label.label8')}}-->
<!--          </span>-->
<!--        </div>-->
      </div>
      <div class="GridD2371EF7">
        <div class="btns">
          <md-button :text="'按钮'" :type="'primary'" :round="true" @click="toMyPosition" class="firBtn">{{$t('label.label216')}}</md-button>
          <md-button :text="'按钮'" :type="'primary'" :round="true" @click="toListPage" class="secBtn">{{$t('label.label2')}}</md-button>
        </div>
        <p class="timeSpan">
          {{$t('label.label4')}}
        </p>
      </div>
    </div>

  </div>
</template>
<script>
import { Button, Dialog, Icon, Toast, Landscape } from '@gidc/mobile'
import backImg from '../../assets/images/homePage.png'
import backImg1 from '../../assets/images/homePageNew.png'

import { mapGetters } from 'vuex'
import { BUYTIMESTATE } from '../../api/smartdeposit'
export default {
  name: 'homePage',
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Landscape.name]: Landscape
  },
  computed: {
    ...mapGetters([
      'RnInfo'
    ])
  },
  watch: {
    RnInfo: function (v) {
      this.changeLang()
      Toast.hide()
      // this.getDataList()
      // this.$i18n.locale = this.RnInfo.language
      // console.log('this is token', v)
    }
  },
  data () {
    return {
      backImg: {
        backgroundImage: 'url(' + backImg + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      },
      backImg1: backImg1,
      isShow: false,
      showCustomTransition: true
    }
  },
  methods: {
    goBack () {
      window.emitRNFunction('goToPage')
    },
    toPage () {
      if (this.RnInfo.token) {
        this.$store.commit('prodClass', 'FP102')
        this.getTime('FP102')
      } else {
        Dialog.alert({
          content: this.$t('label.label9'),
          cancelText: this.$t('btn.btn2'),
          confirmText: this.$t('btn.btn1'),
          onConfirm: () => {
            window.emitRNFunction('goToLogin')
            console.log(this.RnInfo)
          }
        })
      }
    },
    getTime () {
      this.$remote.post(BUYTIMESTATE + '?_locale=' + this.$exchangeLang(this.RnInfo.language), {}, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.buyTimeState === 'true') {
            this.$router.push({ name: 'IntelligentDepositProducts' })
          } else {
            Dialog.alert({
              content: this.$t('label.label3'),
              cancelText: this.$t('btn.btn2'),
              confirmText: this.$t('btn.btn1'),
              onConfirm: () => window.emitRNFunction('goToPage')
            })
          }
        })
    },
    toListPage () {
      if (this.RnInfo.token) {
        this.$router.push('ProductCategories')
      } else {
        Dialog.alert({
          content: this.$t('label.label9'),
          cancelText: this.$t('btn.btn2'),
          confirmText: this.$t('btn.btn1'),
          onConfirm: () => {
            window.emitRNFunction('goToLogin')
            console.log(this.RnInfo)
          }
        })
      }
    },
    changeLang () {
      // 語言設置
      const a = this.RnInfo.language
      let result
      switch (a) {
        case 'en_US': result = 'en'
          break
        case 'zh_CN': result = 'zh'
          break
        case 'zh_HK': result = 'tc'
          break
      }
      this.$i18n.locale = result
      this.label1 = this.$t('btn.btn1')
      this.label2 = this.$t('btn.btn2')
      this.$remote.setBtn(this.label1, this.label2)
    },
    toMyPosition () {
      if (this.RnInfo.token) {
        this.$router.push({ name: 'myPosition', params: { path: 'homePage' } })
      } else {
        Dialog.alert({
          content: this.$t('label.label9'),
          cancelText: this.$t('btn.btn2'),
          confirmText: this.$t('btn.btn1'),
          onConfirm: () => {
            window.emitRNFunction('goToLogin')
            console.log(this.RnInfo)
          }
        })
      }
    }
  },
  mounted () {
    const timeInterval = setInterval(() => {
      if (window.emitRNFunction) {
        window.emitRNFunction('getToken') // 用来获取token
        clearInterval(timeInterval)
      }
    }, 500)
  },
  created () {
  }
}
</script>
<style lang="stylus">
  #homePage{
    .GridD2371EF7{
      .md-button{
        height .88rem
        line-height .88rem
        flex 1
        margin 0 .15rem .1rem
        .md-button-inner{
          .md-button-content{
            height .45rem
            font-size .32rem
            font-weight 500
            line-height .45rem
          }
        }
      }
      .secBtn .md-button-content{
        color #2C80F4
      }
      .md-button.primary.secBtn{
        background linear-gradient(360deg, #D8E8FE 0%, #F7FAFE 100%)
      }
      .md-button.primary:after{
        border .03rem solid #FFFFFF
      }
      .md-button.round{
        border-radius .44rem
      }
    }
  }
</style>
<style lang="stylus" scoped>
  #homePage{
    .Grid6DF38708{
      height 100vh
      position relative
      overflow auto
      .returnBtn{
        height .45rem
        font-size .32rem
        font-weight 400
        color #FFFFFF
        line-height .45rem
        position absolute
        left 5%
        top 4%
        transform translate(-50%,-50%)
      }
      .myPosition{
        height .45rem
        font-size .32rem
        font-weight 400
        color #FFFFFF
        line-height .45rem
        position absolute
        right 10%
        top 4%
        transform translate(50%,-50%)
      }
      .GridA80946D5{
        display flex
        flex-direction column
        align-items center
        .text5631D312{
          padding-top 1.2rem
          font-size .56rem
          line-height .66rem
          color #FFFFFF
          font-weight 600
          text-align center
        }
        .text5631D313{
          padding-top .3rem
          font-size .32rem
          font-weight 400
          color #FFFFFF
          line-height .45rem
          text-align center
        }
      }
      .GridD2371EF7{
        width 100%
        box-sizing border-box
        padding .2rem .45rem .5rem
        .btns{
          display flex
          flex-direction row
          padding-bottom .31rem
        }
        .timeSpan{
          text-align center
          height .33rem
          font-size .24rem
          font-weight 400
          color #FFFFFF
          line-height .33rem
        }
      }
      .newPlans{
        padding .5rem .5rem .5rem
        .newPlan{
          width 100%
          border-radius .2rem
          display flex
          align-items center
          span{
            padding-left .72rem
            margin-top -.15rem
            color #FFFFFF
            height .5rem
            font-size .36rem
            font-weight 500
            line-height .5rem
            text-shadow 0 .1rem 2rem rgba(126, 131, 137, 0.3);
          }
        }
      }
    }
   /* .Grid6DF38708::after{
      content ''
      width 2.68rem
      height .1rem
      background #010101
      position fixed
      left 50%
      top 98%
      transform translate(-50%,-50%)
      border-radius .05rem
    }*/
  }
</style>
